import React, { useState } from 'react';
import { Input, Textarea } from '../../../styles';
import styled from 'styled-components';
import { emailPlaceholder, namePlaceholder, phonePlaceholder } from '../../../utils/data';
import { useSalesContext } from '../../../context/sales_context';

const CustomersDetails = () => {

    const [showDetails, setshowDetails] = useState(false);

    const {
        orderField, handleOrderField,
    } = useSalesContext();

    return (
        <StyledCustomerDetails>
            <div className="mb-4">
                <h6 className="pry-bold-text br-sm p-2 sec-bold"> Customer Details</h6>
            </div>

            <form>
                <div className="row justify-content-center">

                    <div className="col-md-6 col-6">
                        <label className="m-0"><small>  Date:</small> </label>
                        <Input
                            type="date"
                            name="sales_time"
                            onChange={handleOrderField}
                            value={orderField.sales_time}
                            required
                        />
                    </div>

                    <div className="col-md-6 col-6">
                        <label className="m-0"><small>  Customer Phone:</small> </label>

                        <Input
                            type="number"
                            name="customer_phone"
                            placeholder={phonePlaceholder}
                            onChange={handleOrderField}
                            value={orderField.customer_phone}
                        />
                    </div>

                    <div className="col-md-6 ">
                        <label className="m-0"><small>  Customer Name:</small> </label>
                        <Input
                            type="text"
                            name="customer_name"
                            placeholder={namePlaceholder}
                            onChange={handleOrderField}
                            value={orderField.customer_name}
                        />
                    </div>

                    <div className="col-md-6 ">
                        <label className="m-0"><small>  Customer Email:</small> </label>
                        <Input
                            type="text"
                            name="customer_mail"
                            placeholder={emailPlaceholder}
                            onChange={handleOrderField}
                            value={orderField.customer_mail}
                        />
                    </div>

                    <div className="col-md-12 ">
                        <div className="d-flex align-items-center">
                            <label className="ml-2 m-0 small" for="details"> Description: </label>
                            <input
                                name="details"
                                type="checkbox"
                                id="details"
                                value="details"
                                onClick={(e) => setshowDetails(!showDetails)}
                                checked={showDetails}
                                className='ms-2'
                            />
                        </div>

                        {showDetails &&
                            <>
                                <Textarea
                                    type="text"
                                    name="details"
                                    rows="3"
                                    onChange={handleOrderField}
                                    required
                                    placeholder="Description (optional) "
                                    value={orderField.details}
                                ></Textarea>
                            </>
                        }
                    </div>
                </div>
                <div className="my-4">
                    <h6 className="pry-bold-text br-sm p-2 sec-bold"> Item Details</h6>
                </div>

            </form>

        </StyledCustomerDetails>
    );
};

export default CustomersDetails;


const StyledCustomerDetails = styled.section`
    
    input {
     height: 35px;
    }

`;